import { React, useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Skeleton from '@mui/material/Skeleton';
import { useSnackbar } from 'notistack';
import TokenService from '../../../services/TokenService';

export default function TodaysCounts(props) {
    const [isFetching, setIsFetching] = useState(true);
    const [panelData, setPanelData] = useState(null);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    useEffect(() => {
        loadData(); // only called once
    }, []);

    function loadData() {
        
        TokenService.adminServicePost({ date: '' } , 'Admin_DashboardDailyCounts')
            .then((response) => {
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    let data = JSON.parse(response.JsonData);
                    setPanelData(data);
                    setIsFetching(false);
                }
            })
            .catch((response) => {
                enqueueSnackbar('Error in Todays Counts', {
                    variant: 'error',
                });
            });

    }

    function buildLoading() {
        return (
            <div>
                <div className='DashboardPanelHeader'>Todays Counts</div>
                <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Skeleton width={100} height={25} style={{ alignSelf: 'center', marginRight: '30px' }} />
                        <Skeleton width={25} height={25} style={{ alignSelf: 'center' }} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Skeleton width={100} height={25} style={{ alignSelf: 'center', marginRight: '30px' }} />
                        <Skeleton width={25} height={25} style={{ alignSelf: 'center' }} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Skeleton width={100} height={25} style={{ alignSelf: 'center', marginRight: '30px' }} />
                        <Skeleton width={25} height={25} style={{ alignSelf: 'center' }} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Skeleton width={100} height={25} style={{ alignSelf: 'center', marginRight: '30px' }} />
                        <Skeleton width={25} height={25} style={{ alignSelf: 'center' }} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Skeleton width={100} height={25} style={{ alignSelf: 'center', marginRight: '30px' }} />
                        <Skeleton width={25} height={25} style={{ alignSelf: 'center' }} />
                    </div>
                </div>
            </div>
        )
    }

    function handleShowPendingVerifications() {
        if (props.viewRecyclers !== undefined) {
            props.viewRecyclers('PendingVerifications', panelData.PendingIDVerification)
        }
    }

    function handleShowPendingMarketingRequests() {
        if (props.viewRecyclers !== undefined) {
            props.viewRecyclers('PendingMarketingRequests', panelData.PendingMarketingRequests)
        }
    }

    function showCharityReviewsPending() {
        if (props.showCharitiesPendingReview !== undefined) {
            props.showCharitiesPendingReview();
        }
    }

    function buildPanel() {
        return (
            <div>
                <div className='DashboardPanelHeader'>Todays Counts</div>
                <div className='DashboardPanelRows'>
                    {panelData.PendingIDVerification.length == 0 ? null :
                        <div style={{ display: 'flex', justifyContent: 'space-between', color: 'var(--sipzee-red)' }} onClick={() => handleShowPendingVerifications()}>
                            <div>Pending ID Verification</div>
                            <div>{panelData.PendingIDVerification.length}</div>
                        </div>
                    }
                    {panelData.MissedPickups == 0 ? null :
                        <div style={{ display: 'flex', justifyContent: 'space-between', color: 'var(--sipzee-red)' }} onClick={() => props.viewOrders('Missed')}>
                            <div>Missed</div>
                            <div>{panelData.MissedPickups}</div>
                        </div>
                    }
                    {panelData.UnactivatedRequests.length == 0 ? null :
                        <div style={{ display: 'flex', justifyContent: 'space-between', color: 'var(--sipzee-red)' }} onClick={() => props.viewOrders('UnactivatedRequests')}>
                            <div>Unactivated Requests</div>
                            <div>{panelData.UnactivatedRequests}</div>
                        </div>
                    }
                    {panelData.PendingMarketingRequests.length == 0 ? null :
                        <div style={{ display: 'flex', justifyContent: 'space-between', color: 'var(--sipzee-red)' }} onClick={() => handleShowPendingMarketingRequests()}>
                            <div>Marketing Material Requests</div>
                            <div>{panelData.PendingMarketingRequests.length}</div>
                        </div>
                    }
                    {panelData.CharityReviews == 0 ? null :
                        <div style={{ display: 'flex', justifyContent: 'space-between', color: 'var(--sipzee-red)' }} onClick={() => showCharityReviewsPending()}>
                            <div>Charity/Fundraiser Reviews</div>
                            <div>{panelData.CharityReviews}</div>
                        </div>
                    }
                    <div style={{ display: 'flex', justifyContent: 'space-between' }} onClick={() => props.viewOrders('Unscheduled')} >
                        <div>Unscheduled</div>
                        <div>{panelData.Unscheduled}</div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }} onClick={() => props.viewOrders('Scheduled')} >
                        <div>Scheduled Today</div>
                        <div>{panelData.ScheduledToday}</div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }} onClick={() => props.viewOrders('ScheduledFuture')} >
                        <div>Scheduled in the future</div>
                        <div>{panelData.ScheduledFuture}</div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }} onClick={() => props.viewOrders('CreatedToday')} >
                        <div>Created Today</div>
                        <div>{panelData.CreatedToday}</div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }} onClick={() => props.viewOrders('CreatedYesterday')} >
                        <div>Created Yesterday</div>
                        <div>{panelData.CreatedYesterday}</div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }} onClick={() => props.viewOrders('CompletedToday')}>
                        <div>Completed Today</div>
                        <div>{panelData.CompletedToday}</div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }} onClick={() => props.viewOrders('CompletedYesterday')}>
                        <div>Completed Yesterday</div>
                        <div>{panelData.CompletedYesterday}</div>
                    </div>
                </div>
            </div>
        )
    }
    //Admin_DashboardCountsReport

    return (
        <Card sx={{ minWidth: 300, maxWidth: 400, width: '95%', alignSelf: 'center', margin: '10px' }}>
            <CardContent>
                {isFetching ?
                    buildLoading()
                    :
                    buildPanel()
                }
            </CardContent>
        </Card>
    )
}